export default __webpack_public_path__ + "static/media/my_image.fbc61c02.JPG";